/**
 * Tailwind needs literal class names at build time, so the palette is mapped
 * rather than interpolated (`border-l-${color}-500` would be purged).
 */
const BORDER: Record<string, string> = {
  red: 'border-l-red-500',
  blue: 'border-l-blue-500',
  yellow: 'border-l-yellow-500',
  green: 'border-l-green-500',
  purple: 'border-l-purple-500',
  orange: 'border-l-orange-500',
  cyan: 'border-l-cyan-500',
};

const DOT: Record<string, string> = {
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  yellow: 'bg-yellow-500',
  green: 'bg-green-500',
  purple: 'bg-purple-500',
  orange: 'bg-orange-500',
  cyan: 'bg-cyan-500',
};

const TEXT: Record<string, string> = {
  red: 'text-red-400',
  blue: 'text-blue-400',
  yellow: 'text-yellow-400',
  green: 'text-green-400',
  purple: 'text-purple-400',
  orange: 'text-orange-400',
  cyan: 'text-cyan-400',
};

const BG_SOFT: Record<string, string> = {
  red: 'bg-red-500/10',
  blue: 'bg-blue-500/10',
  yellow: 'bg-yellow-500/10',
  green: 'bg-green-500/10',
  purple: 'bg-purple-500/10',
  orange: 'bg-orange-500/10',
  cyan: 'bg-cyan-500/10',
};

const TOP_RULE: Record<string, string> = {
  red: 'border-t-red-500',
  blue: 'border-t-blue-500',
  yellow: 'border-t-yellow-500',
  green: 'border-t-green-500',
  purple: 'border-t-purple-500',
  orange: 'border-t-orange-500',
  cyan: 'border-t-cyan-500',
};

export function bgSoftClass(color: string): string {
  return BG_SOFT[color] ?? 'bg-white/5';
}

export function topRuleClass(color: string): string {
  return TOP_RULE[color] ?? 'border-t-gray-600';
}

export function borderClass(color: string): string {
  return BORDER[color] ?? 'border-l-gray-600';
}

export function dotClass(color: string): string {
  return DOT[color] ?? 'bg-gray-600';
}

export function textClass(color: string): string {
  return TEXT[color] ?? 'text-gray-400';
}

/** "3 hours ago" — Guardian-style recency stamp for cards. */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const minutes = Math.round((then - Date.now()) / 60000);
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  if (Math.abs(minutes) < 60) return formatter.format(minutes, 'minute');
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return formatter.format(hours, 'hour');
  return formatter.format(Math.round(hours / 24), 'day');
}

/** 2026-10-27T05:53:12Z -> "27 Oct 2026, 13:53" in the reader's locale. */
export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
